import { Checkout } from "../interfaces/checkout";

// Gets a new checkout suitable for a cart
export function getNewCheckout(
    providerName: string,
    providerId: number,
    providerCode: string,
): Checkout {
    return {
        state: "start",
        providerName: providerName,
        providerCode: providerCode,
        providerId: providerId,
        programId: 0,
        programName: "",
        clientId: 0,
        clientName: null,
        termsHtml: null,
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        token: null
    };
}
